/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { TaskCardType } from '@/task-manager/entities/task-card-type';
import type { TaskPreview } from '@/task-manager/entities/task-preview';
import { TaskPriority } from '@/task-manager/entities/task-priority';

import {
  type BodyOf,
  type CreateCardViewInputRequest,
  type CreateCardViewOutputSerizalizer,
  tasksV1CardsNewCreate,
} from '../fetch-client';
import { ListTasks } from '../queries/list-tasks';
import { useFetchOpts } from '../use-fetch-opts';

export namespace CreateStandardTask {
  export type Input = Pick<TaskPreview, 'title' | 'status'> & {
    assetId?: string;
  };
  export type Output = { id: string };

  function bodyFromInput(input: Input): BodyOf<typeof tasksV1CardsNewCreate> {
    let body: CreateCardViewInputRequest = {
      title: input.title,

      card_type: TaskCardType.STANDARD,
      priority: TaskPriority.LOW,
      status: input.status,
    };

    if (input.assetId) {
      body = { ...body, level: 'system', accure_id: input.assetId };
    }

    return {
      createCardViewInputRequest: body,
    };
  }

  function outputFromResult(result: CreateCardViewOutputSerizalizer): Output {
    return { id: result.uuid };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();
    const queryClient = rq.useQueryClient();
    const [listTasksFilters] = ListTasks.useGetFiltersFromQueryParams();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        const result = await ok(tasksV1CardsNewCreate(body, opts));
        const output = outputFromResult(result);
        return output;
      },
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ListTasks.key({ filters: listTasksFilters }),
        });
      },
    });
  }
}
